global.jQuery = global.$ = window.jQuery = require('jquery');
var skrollr = require('skrollr');
var ScrollMagic = require('ScrollMagic');
var mixitup = require('mixitup');
require('velocity');
require('cookie');
import 'core-js/features/number/is-nan'
import 'custom-event-polyfill'
import {
	Navigation,
	Autoplay,
	Pagination,
	EffectFade,
	Swiper,
	Thumbs
} from 'swiper'
Swiper.use([Pagination, Autoplay, Navigation, EffectFade, Thumbs])
import {
	gsap
} from "gsap";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/ScrollToPlugin";
import { RoughEase
} from "gsap/EasePack";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, RoughEase);
import ScrollHint from 'scroll-hint';
new ScrollHint('.js-scrollable');

const mainElement = document.querySelector("main");
$(function () {

	// Burger Menu Viewport
	const setFillHeight = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', '${vh}px');
	}

	window.addEventListener('resize', setFillHeight);

	setFillHeight();

	var swiper = new Swiper('.c-slide', {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		effect: 'fade',
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: '.c-slide__next',
			prevEl: '.c-slide__prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
		fadeEffect: {
			crossFade: true
		}
	});
	
	/* cookie */
	let url = location.href.split('/');
	let last = url.slice(-1)[0];
	let meta = last.replace("?meta=", "");
	
	console.log(url);
	
	if(meta == 'recruit'){
		$.cookie('metacookie', 'aru', { expires: 7,path: '/'});
		var metaUser = $.cookie('metacookie');
	}
	
	let kakunin = $.cookie('metacookie');
	
	console.log(kakunin);
	
	
	if(kakunin == "aru"){
		$('.l-header__entry').attr("href","https://www.career-cloud.asia/26/form/entryb/select/afc42622da231d72b4f8cc75f416c0b5");
		$('.l-navGlobal__button').attr("href","https://www.career-cloud.asia/26/form/entryb/select/afc42622da231d72b4f8cc75f416c0b5");
		$('.l-footer__button').eq(1).attr("href","https://www.career-cloud.asia/26/form/entryb/select/afc42622da231d72b4f8cc75f416c0b5");
		$('.p-guideline-nav ul li.-tab a').attr("href","https://www.career-cloud.asia/26/form/entryb/select/afc42622da231d72b4f8cc75f416c0b5");
	}
	
	
/* 	var mySwiper = new Swiper('.p-footer__title', {
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		loop: true,
		freeMode: false,
		slidesPerView: 1.5,
		speed: 6000,
		spaceBetween: 10,
		slidesPerView: 1.5,
		breakpoints: {
			992: {
				spaceBetween: 30,
				slidesPerView: 3
			}
		}
	});
	mySwiper.on('slideChangeTransitionEnd', function (swiper) {
		swiper.autoplay.start();
	});
	window.addEventListener('load', function(){
	  mySwiper(); // ページ読み込み後に初期化
<<<<<<< HEAD
	}); */
/* =======
	}); */
	
	var caseSwiper = new Swiper('.p-case-swiper', {
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},

		loop: true,
		slidesPerView: 1,
		speed: 2000,
		spaceBetween: 30,
		breakpoints: {
			992: {
				slidesPerView: 4,
				spaceBetween: 30
			}
		}

	});
	
	var interviewSwiper = new Swiper('.p-footer-interview__list', {
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		loop: true,
		freeMode: false,
		slidesPerView: 1.5,
		speed: 2000,
		spaceBetween: 30,
		slidesPerView: 1.5,
		centeredSlides: true,
		breakpoints: {
			992: {
				spaceBetween: 110,
				slidesPerView: 3.7
				// centeredSlides: false
			}
		}
	});
/* <<<<<<< HEAD */
/* >>>>>>> feature/知念対応分 */
/* ======= */
	
	const swiperSlides = document.getElementsByClassName("swiper-slide");
	const breakPoint = 768;
	let swiperCulture;
	let swiperBool;

	window.addEventListener(
		"load",
		() => {
			if (breakPoint < window.innerWidth) {
				swiperBool = false;
			} else {
				createSwiper();
				swiperBool = true;
			}
		},
		false
	);

	window.addEventListener(
		"resize",
		() => {
			if (breakPoint < window.innerWidth && swiperBool) {
				swiper.destroy(false, true);
				swiperBool = false;
			} else if (breakPoint >= window.innerWidth && !swiperBool) {
				createSwiper();
				swiperBool = true;
			}
		},
		false
	);

	const createSwiper = () => {
		swiperCulture = new Swiper(".p-culture-slide", {
			loop: true,
			navigation: {
				nextEl: ".p-culture-slide__next",
				prevEl: ".p-culture-slide__prev",
			}
		});
	};
/* >>>>>>> feature/知念対応分 */

	// Page Top

	const pagetop = $('.p-footer__pagetop');
	pagetop.on('click', function () {
		gsap.to(window, {
			duration: 1,
			scrollTo: 0
		});
	});

	// anchor link
	$('a[href^="#"]').click(function () {
		var speed = 500,
			href = $(this).attr("href"),
			target = $(href == "#" || href == "" ? 'html' : href),
			offset = target.offset().top,
			headerHeight = $('.l-header').innerHeight(),
			position = offset - headerHeight;

		$("html, body").animate({
			scrollTop: position
		}, speed, "swing");
		return false;
	});

	// Global Navigation

	/* const burger = $('.menuAction');
	const gnav = $('.l-navGlobal');
	const header = $('.l-header');
	let burgerFlag = false;
	burger.each(function () {
		burger.on('click', function () {
			if (!burgerFlag) {
				burger.addClass('isOpen');
				gnav.addClass('isActive');
				burgerFlag = true;
				header.addClass('isActive');
			} else {
				burger.removeClass('isOpen');
				gnav.removeClass('isActive');
				header.removeClass('isActive');

				burgerFlag = false;
			}
		});
	}); */

	const burger = $('.c-burger');
	const gnav = $('.l-navGlobal');
	const header = $('.l-header');
	const anchorLinks = $('.l-navGlobal__item a'); // Selecting anchor links
	let burgerFlag = false;

	function toggleMenu() {
			if (!burgerFlag) {
					burger.addClass('isOpen');
					gnav.addClass('isActive');
					header.addClass('isActive');
					burgerFlag = true;
			} else {
					burger.removeClass('isOpen');
					gnav.removeClass('isActive');
					header.removeClass('isActive');
					burgerFlag = false;
			}
	}

	burger.on('click', toggleMenu);
	anchorLinks.on('click', toggleMenu); // Adding click event to anchor links


	checkHeaderClass();

	function checkHeaderClass() {
		if (burger.hasClass('isOpen')) {
			burger.removeClass('isOpen');
		}
		if (gnav.hasClass('isActive')) {
			gnav.removeClass('isActive');
		}
		if (header.hasClass('isActive')) {
			header.removeClass('isActive');
		}
		burgerFlag = false;
	}

	var controller = new ScrollMagic.Controller();
	var jsAddClasses = Array.prototype.slice.call(document.getElementsByClassName('js-active')),
		jsShapeClasses = Array.prototype.slice.call(document.getElementsByClassName('js-shape')),
		jsMoveSimples = Array.prototype.slice.call(document.getElementsByClassName('js-view')),
		jsMoveMultis = Array.prototype.slice.call(document.getElementsByClassName('js-multi'));

	jsShapeClasses.map(function (jsShapeClass) {
		return new ScrollMagic.Scene({
				triggerElement: '#hakka',
				triggerHook: 0.8,
				offset: 300
			}).setClassToggle(jsShapeClass, 'is-active')
			.addIndicators()
			.addTo(controller);
	});

	$('.js-view , .js-move').velocity({
		opacity: 0,
		translateY: 30
	}, 40);

	$('.js-left').velocity({
		opacity: 0,
		translateX: 60,
		translateY: 0
	}, 40);

	$('.js-right').velocity({
		opacity: 0,
		translateX: (-60),
		translateY: 0
	}, 40);

	function multiMoves(_event, _this) {
		var $self = $(_this);
		$self.find('.js-move').each(function (index) {
			$(this).velocity({
				opacity: 1,
				translateY: 0,
				translateX: 0
			}, {
				delay: 250 * index,
				duration: 800
			});
		});
	}

	function simpleMove(_event, _this) {
		var $self = $(_this);
		$self.velocity({
			opacity: 1,
			translateX: 0,
			translateY: 0
		}, {
			duration: 800
		});
	}


	jsMoveSimples.map(function (jsMoveSimple) {
		return new ScrollMagic.Scene({
			triggerElement: jsMoveSimple,
			triggerHook: 0.8,
			reverse: false,
		}).on('enter', function (event) {
			var thisTarget = jsMoveSimple;
			simpleMove(event, thisTarget);
		}).addTo(controller);
	});

	jsMoveMultis.map(function (jsMoveMulti) {
		return new ScrollMagic.Scene({
			triggerElement: jsMoveMulti,
			triggerHook: 0.8,
			reverse: false,
		}).on('enter', function (event) {
			var thisTarget = jsMoveMulti;
			multiMoves(event, thisTarget);
		}).addTo(controller);
	});


	const jsShape = function () {



		$('.js-shape').each(function (index) {
			$(this).velocity({
				translateX: (Math.floor(Math.random() * 6) + 4) % 7 - 3 + '%',
				translateY: (Math.floor(Math.random() * 6) + 4) % 7 - 3 + '%',
				borderTopLeftRadius: String(Math.round(50 * Math.random() + 20) + "%"),
				borderTopRightRadius: String(Math.round(50 * Math.random() + 20) + "%"),
				borderBottomLeftRadius: String(Math.round(50 * Math.random() + 20) + "%"),
				borderBottomRightRadius: String(Math.round(50 * Math.random() + 20) + "%")
			}, {
				duration: 3000,
				loop: true
			});

		});

	}

	jsShape();
	
	if (mainElement.classList.contains('p-interview-top')) {
		var mixer = mixitup('.p-interview-top-list');
	}
	
	

	const categoryBtn = $('.p-interview-top-category__btn button');
	categoryBtn.on('click', function () {
		var topList = $('.p-interview-top-list');
		var topListPos = topList.offset();
		gsap.to(window, {
			duration: 1,
			scrollTo: topListPos.top - 40
		});
	});
	
	const interviewTopSwiper = new Swiper(".p-interview-top-hero__swiper.-up", {
		direction: "vertical",
		spaceBetween: 10,
		slidesPerView: "auto",
		loop: true,
		speed: 10000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
		},
		breakpoints: {
			768: {
				spaceBetween: 20,
			}
		}
	});
	
	const interviewTopSwiperRev = new Swiper(".p-interview-top-hero__swiper.-down", {
		direction: "vertical",
		spaceBetween: 10,
		slidesPerView: "auto",
		loop: true,
		speed: 10000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
			reverseDirection: true,
		},
		breakpoints: {
			768: {
				spaceBetween: 20,
			}
		}
	});
	
});


/*---------------------------------------------
	skrollr setting
---------------------------------------------*/

var isMobile = false;

isMobile = $('html').is('.skrollr-mb');

if (!isMobile) {
	window.onload = function () {
		var s = skrollr.init({
			forceHeight: false,
			mobileDeceleration: 0.01,
			mobileCheck: function () {
				return isMobile;
			}
		});
	}
}

/*---------------------------------------------
	top page
---------------------------------------------*/
document.addEventListener("DOMContentLoaded", function() {
	if (mainElement.classList.contains('p-top-main')) {
		gsap.set(".p-top-hero__holder",{opacity:0},)
		gsap.set(".p-top-hero__copy",{opacity:0},)
		var progressBars = document.querySelectorAll(".p-top-hero__sct01-main");
		var maxDuration = 800; // 最大表示時間（例: 2000ミリ秒）
		var startTime = Date.now();

		let heroCopy = document.querySelectorAll(".p-top-hero__copy");
		let heroHolder = document.querySelectorAll(".p-top-hero__holder");
		let heroCopyStroke = document.querySelector(".p-top-hero__sct01-main-stroke");

		function updateProgressBar() {
				var elapsedTime = Date.now() - startTime;
				var progress = elapsedTime / maxDuration * 100;
				progressBars.forEach(function(progressBar) {
					progressBar.style.maskPosition = 100 - Math.min(progress, 100) + '% 0';
					progressBar.style.webkitMaskPosition = 100 - Math.min(progress, 100) + '% 0';
					//progressBar.style.width = Math.min(progress, 100) + '%';
				});


				if (elapsedTime < maxDuration && progressBars[0].style.maskPosition !== "0 0") {
						requestAnimationFrame(updateProgressBar);
				} else {
						progressBars.forEach(function(progressBar) {
							progressBar.style.maskPosition = '0 0';
							progressBar.style.webkitMaskPosition = '0 0';
						});
						animateText(heroCopy,".p-top-hero",6);
						setTimeout(function() {
							animateText(heroHolder,".p-top-hero",5);
						}, 600); // 完了後に非表示にするまでの遅延時間
						//console.log("end")
						setTimeout(function() {
							heroCopyStroke.style.display = 'none';
								mvMove()
						}, 1500); // 完了後に非表示にするまでの遅延時間
				}
		}

		updateProgressBar();
	}
});

function mvMove(){
	gsap.set(topMvBg01,{opacity:1});
	gsap.set(topMvCopy,{scale:1.0,opacity:0.6,filter: "blur(0px)"});
	gsap.set(topMvCopy01,{top:"calc(50vh - 10vw)"});
	gsap.set(topMvCopy02,{bottom:"calc(50vh - 10vw)"});

	let topMv = gsap.timeline()

	ScrollTrigger.create({
		animation: topMv,
		trigger: '.p-top-hero',
		start: "top bottom",
		end: "bottom top",
		//scrub: true,
		//yoyo: true,
	});

	if (window.matchMedia("(max-width: 767px)").matches) {
		topMv.to(topMvCopy01,{top:"calc(0vh - 0vw)", opacity:0.5, filter: "blur(2.5px)", duration: 0.6,},0);
		topMv.to(topMvCopy02,{bottom:"calc(0vh - 0vw)", opacity:0.5, filter: "blur(2.5px)", duration: 0.6,},0);
	} else if (window.matchMedia("(min-width:768px)").matches) {
		topMv.to(topMvCopy,{scale:1.1,opacity:0.5, filter: "blur(12.5px)", duration: 0.6,},0);
		topMv.to(topMvCopy01,{top:"calc(0vh - 0vw)", duration: 0.6,},0);
		topMv.to(topMvCopy02,{bottom:"calc(0vh - 0vw)", duration: 0.6,},0);
	}
	topMv.addLabel("topMv-Label_1");
	topMv.to(topMvBg01, {
		opacity: 0,
		duration: 0.5,
	}, "topMv-Label_1-=0.4");
}






/*---------------------------------------------
	message page
---------------------------------------------*/

const totalScenes = 3; //メッセージのセクション（画像）数に合わせて変更
const scenes = [];



gsap.registerEase(
	'flicker',
	// eslint-disable-next-line max-len
	"rough({ template: power0.none, strength: 10, points: 20, taper: 'none', randomize: true, clamp:  true})"
);
gsap.registerEase(
	'flickerMin',
	"rough({ template:bounce.out, strength: 12, points:3, taper:out, randomize:true, clamp:true})"
);

function animateText(targets,trigger,test) {
	// GSAPアニメーションを適用
	let funcAnimation = gsap.timeline()
	// 指定された要素を取得
	//const element = document.querySelector(target);

	targets.forEach(target => {
		// ここにアニメーションのロジックを配置
		const element = target;
		const text = element.innerHTML;
		// まず、<br>タグでテキストを分割し、各セグメントを<div>で囲む
		const divsAndChars = text.split("<br>").map(segment => {
			/* let demoContainer = document.getElementById('demo');
			let existingText = demoContainer.textContent;
			demoContainer.textContent = existingText + "<br>" + segment; */
			const div = document.createElement("div");
			div.style.display = "block";
			const tempDiv = document.createElement("div"); // 一時的なdiv要素を作成
			tempDiv.innerHTML = segment; // HTMLコンテンツを設定
			const chars = tempDiv.textContent || tempDiv.innerText; // 純粋なテキストを抽出

			// 次に、各セグメント内の文字を<span>で囲む
			const spans = chars.split("").map(char => {
					const span = document.createElement("span");
					span.style.display = "inline-block";
					span.innerHTML = char === " " ? "&nbsp;" : char;
					return span;
			});

			// 作成した<span>要素を<div>に追加
			spans.forEach(span => {
					div.appendChild(span);
			});

			return { div, spans };
		});

		const divs = divsAndChars.map(item => item.div);
		const chars = divsAndChars.map(item => item.spans).flat(); // flat()を使用して、すべてのspan要素を一つの配列に平坦化する

		// 元の要素の内容をクリアし、新しい<div>要素を追加
		element.innerHTML = "";
		divs.forEach(div => {
			element.appendChild(div);
		});

		if(test === 1){

			/* let interviewItem = []
			gsap.utils.toArray(".p-footer-interview-item").forEach((target,num) => {
				interviewItem.push(gsap.timeline());
				ScrollTrigger.create({
					animation: interviewItem[num],
					trigger: target,
					start:'left right',
					end:'center left',
					//horizontal:true,
					markers:true,
					scrub:true,
					containerAnimation:horizontalScroll,
				});
				if (num % 2 === 0) {
					interviewItem[num].set(target,{y:-(window.innerHeight - listContent.clientHeight)/2*0.7});
					interviewItem[num].to(target,{y:(window.innerHeight - listContent.clientHeight)/2*0.7,ease:"power1.out",duration:1});
				} else {
					interviewItem[num].set(target,{y:(window.innerHeight - listContent.clientHeight)/2*0.7});
					interviewItem[num].to(target,{y:-(window.innerHeight - listContent.clientHeight)/2*0.7,ease:"power1.out",duration:1});
				}
			}); */


			/* let funcAnimation = []

			gsap.utils.toArray(trigger).forEach((target,num) => {
				funcAnimation.push(gsap.timeline());
				ScrollTrigger.create({
					animation:funcAnimation[num],
					trigger: trigger,
					start: "top bottom",
					//end: "bottom top",
					toggleActions: "play pause resume reverse",
					yoyo: true,
					//markers: true
				});
				gsap.set(chars, {
					opacity: 0,
					//translateY: "15%",
					scaleY: ".92",
					rotate: "2deg",
					skewY: "2deg",
					//filter: "blur(15px)"
				});
				funcAnimation.to(chars, {
					duration: 0.4,
					opacity: 1,
					//translateY: "0%",
					scaleY: "1",
					rotate: "0deg",
					skewY: "0deg",
					//filter: "blur(0)",
					ease: "flicker",
					stagger: function() {
						return Math.random() * 0.08;
					}
				});
			}); */

		}else if(test === 2){
			gsap.set(chars,
				{opacity: 0,},);
			funcAnimation.to(
				chars,
				{
					opacity: 1,
					duration: 0.001,
					stagger: {
						each: 0.008,
					},
					/* scrollTrigger: {
						trigger: target,
						start: 'top center',
						//markers: true
					}, */
				}
			);
		}else if(test === 3){
			ScrollTrigger.create({
				animation:funcAnimation,
				trigger: trigger,
				start: "top top+=50%",
				//end: "bottom top",
				toggleActions: "play pause resume reverse",
				yoyo: true,
				//markers: true
			});
			gsap.set(divs,
				{	opacity: 0,
					translateY: "15%",
				},);
			funcAnimation.to(divs, {
				duration: 0.2,
				opacity: 1,
				translateY: "0%",
				ease: "none",
				stagger: 0.08,
			});
		}else if(test === 4){
			gsap.set(divs,
				{	opacity: 0,
					translateY: "15%",
				},);
			funcAnimation.to(divs, {
				duration: 0.3,
				opacity: 1,
				translateY: "0%",
				ease: "none",
				stagger: 0.08,
			});
		}else if(test === 5){
			ScrollTrigger.create({
				animation:funcAnimation,
				trigger: trigger,
				start: "top top+=50%",
				//end: "bottom top",
				toggleActions: "play pause resume reverse",
				yoyo: true,
				//markers: true
			});
			gsap.set(target,
				{	opacity: 0,
				},);
			gsap.set(chars,
				{	opacity: 0,},);
			funcAnimation.to(target, {
				duration: 0.2,
				opacity: 1,
				translateY: "0%",
				ease: "flicker",
				stagger: 0.08,
			});
			funcAnimation.to(chars, {
				duration: 0.3,
				opacity: 1,
				translateY: "0%",
				ease: "flicker",
				stagger: function() {
					return Math.random() * 0.08;
				}
			});
		}else if(test === 6){
			gsap.set(chars,
				{
					scale: 1.25,
					opacity: 0,
					filter:"blur(25px)"
				},);
			funcAnimation.to(chars, {
				scale: 1,
				duration: 0.5,
				opacity: 1,
				filter:"blur(0px)",
				ease: "none",
				stagger: function() {
					return Math.random() * 0.5;
				}
			});
			funcAnimation.to(target, {
				opacity:1,
			},0);
		}
	});
}


let topMvCopy = '.p-top-hero__wrapper'
let topMvCopy01 = '.p-top-hero__sct01-main.-upper'
let topMvCopy02 = '.p-top-hero__sct01-main.-under'
let topMvBg01 = '.p-top-hero__sct01-bg.-upper'
let topMvBg03 = '.p-top-hero__sct02-bg'
let topMvTitle = '.p-top-hero__mainTitle'
let topMvLogo1 = '.p-top-hero__mainLogo.-logo01'
let topMvVision = '.p-top-hero__mainVision'

function switchByWidth() {
	
	if (document.querySelector('.p-top-hero')){
	
		let topMv = gsap.timeline()
		let topMv_2 = gsap.timeline()
	
		// ビデオ要素を取得
		let video = document.querySelectorAll(`${topMvBg03} video`);
		ScrollTrigger.create({
			animation: topMv,
			trigger: '.p-top-hero',
			start: "top bottom",
			end: "bottom top",
			//scrub: true,
			//yoyo: true,
		});

	//set
	gsap.set(topMvBg01,{opacity:1});

	ScrollTrigger.create({
		animation: topMv_2,
		trigger: '.p-top-hero',
		start: "top top",
		end: "+=50%",
		scrub: true,
		yoyo: true,
		onUpdate: self => { // ここでselfはScrollTriggerインスタンスを参照します
			if (self.progress === 1 && !self.isActive) {
				elementsToHideSelectors.forEach(selector => {
					let elements = document.querySelectorAll(selector);
					elements.forEach(element => {
						element.style.display = "none";
					});
				});
			} else if (self.progress < 1) {
				elementsToHideSelectors.forEach(selector => {
					let elements = document.querySelectorAll(selector);
					elements.forEach(element => {
						element.style.removeProperty('display');
					});
				});
			}
		},
		//markers: true,
	});

	//set
	
	if (window.matchMedia("(min-width:768px)").matches) {
		gsap.set(topMvBg03,{opacity:0.3});
	}
	gsap.set(topMvTitle,{opacity:1});
	gsap.set(topMvLogo1,{filter: "blur(5px)"});
	//to
	topMv_2.to(topMvTitle,{scale:1.5, filter: "blur(6px)", opacity:0, duration: 1,},0);
	topMv_2.to(topMvCopy01,{scale:1.5, yPercent:-150, filter: "blur(20.5px)", duration: 1,},0);
	topMv_2.to(topMvCopy02,{scale:1.5, yPercent:150, filter: "blur(20.5px)", duration: 1,},0);
	/* topMv_2.to(topMvCopy,{height:'100lvh', duration: 1,},0); */
	// スクロールに合わせてビデオの終わりまで再生
	
	if (video.length !== 0) {
		if (window.matchMedia("(max-width: 767px)").matches) {
			topMv_2.to(video[1], {currentTime:video[1].duration, ease: "none", duration: 1,},0);
		} else if (window.matchMedia("(min-width:768px)").matches) {
			topMv_2.to(video[0], {currentTime:video[0].duration, ease: "none", duration: 0.01,},0);
		}
	}
	let elementsToHideSelectors = [topMvBg03, topMvTitle, topMvCopy01, topMvCopy02, topMvBg01, topMvCopy, topMvVision];
	topMv.addLabel("topMv_2-Label_1");
	/* topMv_2.to(
    topMvCopy02,
    {
      opacity: 0,
      duration: 1,
			yoyo: true, // 逆再生を有効にする
      onUpdate: function() {
				console.log("Progress:", this.progress(), "Reversed:", this.reversed());
				if (this.progress() === 1 && !this.reversed()) {
						// アニメーションがend位置に到達した時
						elementsToHideSelectors.forEach(selector => {
								let elements = document.querySelectorAll(selector);
								elements.forEach(element => {
										element.style.display = "none";
								});
						});
				} else if (this.reversed() && this.progress() < 1) {
						// アニメーションが逆再生でend位置に近づいた時（startに戻る直前）
						elementsToHideSelectors.forEach(selector => {
								let elements = document.querySelectorAll(selector);
								elements.forEach(element => {
										element.style.removeProperty('display');
								});
						});
				}
			},
    },
    0
  ); */
	topMv_2.to(topMvCopy01,{opacity:0,duration: 0.5,},"topMv_2-Label_1-=0.5");
	topMv_2.to(topMvCopy02,{opacity:0,duration: 0.5,},"topMv_2-Label_1-=0.5");
	topMv_2.to(topMvBg03,{opacity:0,duration: 0.5,},"topMv_2-Label_1-=0.5");
	topMv_2.to(topMvLogo1,{filter: "blur(0px)",},"topMv_2-Label_1-=0.5");
	/* 	// ビデオがメタデータを読み込んだら、ScrollTriggerアニメーションを設定
		video.addEventListener('loadedmetadata', () => {
	}); */


	function randomFadeTextN(targets){
		document.querySelectorAll(targets).forEach((target) => {
			if (target.classList.contains("u-dib") || target.querySelector('*[class^="u-dib"]')) {
				let dibTargets = target.querySelectorAll('.u-dib')
				dibTargets.forEach((dibTarget)=> {
					let html = '';
					let elementTexts = dibTarget.textContent; // HTMLエンティティを考慮せずにテキスト内容のみを取得
					for (let char of elementTexts) {
							if (char === ' ') {
									html += `<span>&nbsp;</span>`; // 空白文字の処理
							} else {
									html += `<span>${char}</span>`; // 通常の文字
							}
					}
					dibTarget.innerHTML = html;
				});

			} else {
				let html = '';
				let elementTexts = target.textContent.trim();
				elementTexts = elementTexts.split('\n').map(line => line.trimStart()).join('\n');
				for (let char of elementTexts) {
					if (char === ' ') {
						html += `<span>&nbsp</span>`;
					} else if (char === '\n') {
						html += char;
					} else {
						html += `<span>${char}</span>`;
					}
				}
				target.innerHTML = html;
			}
		});

		let funcAnimation = []
		gsap.utils.toArray(targets).forEach((target,num) => {
			funcAnimation.push(gsap.timeline());

			ScrollTrigger.create({
				animation:funcAnimation[num],
				trigger: target,
				start: "top bottom",
				end: "bottom top",
				toggleActions: "play pause play none",
				//once: true, // トリガーを一度限りのものにする
				//markers: true
			});
			gsap.set(target.querySelectorAll("span:not(.u-dib)"), {
				opacity: 0,
				scaleY: ".92",
				rotate: "2deg",
				skewY: "2deg",
			});
			funcAnimation[num].to(target.querySelectorAll("span:not(.u-dib)"), {
				duration: 0.4,
				opacity: 1,
				scaleY: "1",
				rotate: "0deg",
				skewY: "0deg",
				ease: "flicker",
				stagger: function() {
					return Math.random() * 0.08;
				}
			});
		});
	}


	let lineElements = document.querySelectorAll(".animated-line");
	let leadElements = document.querySelectorAll(".animated-lead");
	//lineElements.forEach((lineElement) => {
	animateText(lineElements,".p-top-hero__block",3);
	animateText(leadElements,".p-top-hero__block",5);
	randomFadeTextN(".js-fadeText");
	/* let ttlElements = document.querySelectorAll(".animated-ttl");
	animateText(ttlElements,".p-top-company__lead-title",1); */
	//});

	function hoverRandomText(targets){
		gsap.utils.toArray(targets).forEach((target,num) => {
			target.addEventListener('mouseenter', () => {
				let spans = target.querySelectorAll("span:not(.js-hover-exclusion)");
				gsap.set(spans, {
					opacity: 0,
					scaleY: ".92",
					rotate: "2deg",
					skewY: "2deg",
				});
				let tl = gsap.timeline();
				tl.to(spans, {
					duration: 0.24,
					opacity: 1,
					scaleY: "1",
					rotate: "0deg",
					skewY: "0deg",
					ease: "flickerMin",
					stagger: function() {
						return Math.random() * 0.08;
					}
				},0.1);
			});
		});
	}


	hoverRandomText(".js-hoverText");

	let topLead = gsap.timeline()
	ScrollTrigger.create({
		animation: topLead,
		trigger: '.p-top-hero__block',
		start: "top top",
		end: "bottom top",
		scrub: true,
		yoyo: true,
		//markers: true,
		onUpdate: self => {
			const targetLogo = document.querySelectorAll(".p-top-hero__mainLogo");
			
			if (targetLogo.length !== 0) {
					if (self.progress >= 0.55 && !targetLogo[0].classList.contains("-play")) {
						// 80%以上のプログレスで-playクラスを追加
						targetLogo[0].classList.add("-play");
						targetLogo[1].classList.add("-play");
					} else if (self.progress < 0.55 && targetLogo[0].classList.contains("-play")) {
						// 80%未満で-playクラスを削除
						targetLogo[0].classList.remove("-play");
						targetLogo[1].classList.remove("-play");
					}
					/* if (self.progress >= 1 && targetLogo[1].classList.contains("-play")) {
						targetLogo[1].classList.remove("-play");
						targetLogo[0].classList.add("-play2");
				} */
			}
		},
		/* onLeave: () => gsap.to("canvas",{opacity:1,scale:1.25,duration: 1,yoyo:false,}), */
		/* onLeave: () => gsap.to("canvas",{opacity:1,scale:1.25,duration: 1,yoyo:false,}), */
	});
	topLead.to("canvas",{opacity:0,scale:2.5,duration: 1,},0);
	/* topLead.add(function() { // クラスを付与するためのコールバックを追加
		document.querySelector(".-logo02").classList.add("-play");
	}, "+=0.8"); */


	gsap.to(
		".p-top-hero__mainLogo.-logo02",{transform:'translateY(-90vh)',ease: "none",
		scrollTrigger:{
			trigger: '.p-top-hero__section.-section04',
			start: "top top",
			end: "bottom top",
			scrub: true,
			yoyo: true,
		},},
	);

	gsap.to("canvas",{opacity:1,scale:1.25,
		scrollTrigger:{
			trigger: ".p-top-company__section.-section01",
			start: "top center",
			end: "top center",
			yoyo: true,
			scrub: true,
		},},
	);

	let top_about = gsap.timeline()
	let title01 = '.p-top-company__title-text.-bg01 img'
	let title02 = '.p-top-company__title-text.-bg02 img'
	let about_img = '.p-top-company__title-img'
	ScrollTrigger.create({
		animation: top_about, // scenes配列から適切なtimelineを取得
		trigger: '.p-top-company__section.-section01',
		start: "top bottom",
		end: "bottom top",
		scrub: 2,
		yoyo: true,
		//markers: true,
	});

	gsap.set(title01, {transform: 'translateX(-100vW)', opacity:0});
	gsap.set(title02, {transform: 'translateX(100vW)', opacity:0});
	gsap.set(about_img, {yPercent:25, scale:0.95});
	top_about.addLabel("top_about-Label_1");
	top_about.to(title01,{opacity:1,duration: 0.42,},'top_about-Label_1-=0.42');
	top_about.to(title02,{opacity:1,duration: 0.42,},'top_about-Label_1-=0.42');
	top_about.to(about_img,{yPercent:-15,scale:1.05,duration: 1,},0);
	top_about.to(title01,{transform: 'translateX(80vw)',duration: 1,},0);
	top_about.to(title02,{transform: 'translateX(-60vw)',duration: 1,},0);


	/* let about_test = gsap.timeline();
	ScrollTrigger.create({
		animation: about_test,
		trigger: ".p-top-company__section.-section01",
		start: "top center",
		yoyo:true,
		//markers: true,
	});
	about_test.to("canvas",{opacity:1,scale:1.25,duration: 1});
	about_test.to(".p-top-company__section.-section02",{opacity:1,translateY:"0vh",duration: 0.6});
 */


	let numItems = document.querySelectorAll('.p-top-company__solution-img li').length;
	let photo_fade = gsap.timeline()
	ScrollTrigger.create({
		animation: photo_fade, // scenes配列から適切なtimelineを取得
		trigger: `.p-top-company__section.-section02`,
		start: "top bottom-=25%",
		endTrigger: ".p-top-company__solution-content-category",
		end: 'top top+=35%',
    toggleActions: "play pause resume pause",
		//markers: true,
	});
	gsap.set('.p-top-company__solution-img li',{opacity:0,xPercent:5,yPercent:5,filter: "blur(10px) brightness(10)",});

	for (let i = 1; i <= numItems/2; i++) {
		photo_fade.to(`.p-top-company__solution-img li:nth-child(${i})`, {
			opacity: 1,
			xPercent: 0,
			yPercent: 0,
			filter: "blur(0px) brightness(1)",
			duration: 1.2,
			delay: i * 0.2,
		},0);
	}

	let scroll_text = gsap.timeline()
	ScrollTrigger.create({
		animation: scroll_text, // scenes配列から適切なtimelineを取得
		trigger: `.p-top-company__solution-info-title-en`,
		start: "top bottom",
		end: "bottom+=100%",
		scrub: 2,
		yoyo: true,
		//markers: true,
	});
	scroll_text.to(".p-top-company__solution-info-title-en img",{transform: 'translateX(-5vw)',});

	}

	var headerElement = document.querySelector('header');
	if (document.querySelector('.l-modal') !== null) {
		for (var i = 1; i <= 14; i++) {
			(function(index) {
					var modal = document.getElementById('myModal' + index);
					var openLink = document.getElementById('modalLink' + index);
					var closeLink = document.getElementById('closeModalBtn' + index);
		
					openLink.onclick = function(event) {
							event.preventDefault();
							modal.style.display = "block";
							document.body.style.overflow = 'hidden';
							if (headerElement) {
									headerElement.style.display = 'none';
							}
					}
		
					closeLink.onclick = function(event) {
							event.preventDefault();
							modal.style.display = "none";
							document.body.style.overflow = 'auto';
							headerElement.style.display = 'block';
					}
			})(i);
		}
	}


  if (window.matchMedia("(max-width: 767px)").matches) {
    //スマホ処理

		if (mainElement.classList.contains('p-message-main')) {
			let message_mv = gsap.timeline()
			ScrollTrigger.create({
				animation: message_mv, // scenes配列から適切なtimelineを取得
				trigger: '.p-message-main .-section01',
				start: "top+=12% top",
				end: "+=100%",
				scrub: true,
				yoyo: true,
				//markers: true,
			});
			gsap.set('.p-message-main .-bg01.-sp', {filter: "blur(0px) brightness(1)",});
			gsap.set('.p-message-main .-bg02.-sp', {filter: "blur(0px) brightness(1)",});
			message_mv.to('.p-message-main .-bg01.-sp',{filter: "blur(2px) brightness(1.1)",duration: 0.6,});
			message_mv.to('.p-message-main .-bg02.-sp',{filter: "blur(2px) brightness(1.1)",duration: 0.6,},0);
			message_mv.to('.p-message-main .-bg01.-sp',{filter: "blur(5px) brightness(1.2)",duration: 0.4,});
			message_mv.to('.p-message-main .-bg02.-sp',{filter: "blur(5px) brightness(1.2)",duration: 0.4,},'-=0.4');
			message_mv.to('.p-message-main .p-message-hero__person span',{opacity: 0.25,duration: 1,},0);
	
			for (let i = 1; i <= totalScenes; i++) {
				scenes.push(gsap.timeline());
				ScrollTrigger.create({
					animation: scenes[i - 1], // scenes配列から適切なtimelineを取得
					trigger: `.p-message-main .-interview0${i}`,
					start: "top top+=90%",
					end: "+=65%",
					scrub: 1.25,
					yoyo: true,
					//markers: true,
				});
	
				scenes[i - 1].set(`.p-message-main .-bg-img${i}`, {
					filter: "blur(0px) brightness(1)",
				});
				scenes[i - 1].set(`.p-message-main .-interview0${i}`, {backgroundColor: "rgba(255, 255, 255, 0)",});
	
				scenes[i - 1].to(`.p-message-main .-bg-img${i}`, {opacity: 1,duration: 0.6,});
				scenes[i - 1].addLabel("Label_1");
				scenes[i - 1].to(`.p-message-main .-bg-img${i}`, {filter: "blur(10px) brightness(1.2)",duration: 0.4,},'+=0.15');
				scenes[i - 1].to(`.-interview0${i}`, {backgroundColor: "rgba(255, 255, 255, 0.85)",duration: 0.4,},'Label_1+=0.05');
			}
		}
  } else if (window.matchMedia("(min-width:768px)").matches) {
    //PC処理


    const items = document.querySelectorAll('.p-top-company__culture-list-item');
    const images = document.querySelectorAll('.main-image');

    items.forEach(item => {
        item.addEventListener('mouseover', function() {
            const itemId = this.dataset.cultureItem; // ここで data-culture-item 属性の値を取得
            images.forEach(img => {
                if (img.dataset.cultureBg === itemId) {
										img.classList.add('active');
                } else {
										img.classList.remove('active');
                }
            });
        });
    });


		/* gsap.set(".p-footer-interview-item:nth-child(even)",{
			yPercent: 40,
		});
		gsap.to(".p-footer-interview-item:nth-child(even)",{
			yPercent: -25,
			scrollTrigger:{
				trigger:".p-footer-interview-content",
				start: "top bottom",
				end: "bottom top",
				scrub: .4,
				//markers:true,
			},
		}); */

		const listItems = gsap.utils.toArray(".js-para")
		//console.log(listItems)
		listItems.forEach((target,num) => {
				gsap.to(target.querySelectorAll("img,.js-para-img"),{
					yPercent:-12,
					scrollTrigger:{
						trigger: target,
						start: "top bottom",
						end: "bottom top",
						scrub: .8,
						//markers:true,
					},
				});
		});

		let textSplit = document.querySelectorAll(".js-split");
		if (textSplit) {
			textSplit.forEach((target) => {
				let html = '';
				let elementTexts = target.textContent.trim();

        target.childNodes.forEach(node => {
					if (node.nodeType === Node.TEXT_NODE) {
							// テキストノードの場合は文字ごとに分割
							let elementTexts = target.textContent.trim();
							elementTexts = node.textContent.split('\n').map(line => line.trimStart()).join('\n');
							for (let char of elementTexts) {
									if (char === ' ') {
											html += `<span>&nbsp;</span>`;
									} else if (char === '\n') {
											html += char;
									} else {
											html += `<span>${char}</span>`; // その他の文字
									}
							}
					} else if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('js-split-exclusion')) {
							// 'exclude'クラスを持つ要素ノードの場合は、そのHTMLをそのまま使用
							html += node.outerHTML;
					}
				});
				target.innerHTML = html;

			});
		}



		/* const listWrapperEl = document.querySelector('.p-footer.-scroll .p-footer-interview-wrapper');
		if (listWrapperEl) {
			const listEl = document.querySelector('.p-footer.-scroll .p-footer-interview-list');
			const listContent = document.querySelector('.p-footer.-scroll .p-footer-interview-content');
			const headerContent = document.querySelector('.l-header');

			gsap.set(listWrapperEl, {
				height: window.innerHeight + headerContent.clientHeight,});
			gsap.set(listContent, {
				height: () => (listContent.clientHeight + listEl.clientHeight),});

			let horizontalScroll = gsap.timeline();
			ScrollTrigger.create({
				animation: horizontalScroll,
				trigger: '.p-footer.-scroll .p-footer-interview-test',
				start: `top top`,
				end: () => `+=${listEl.clientWidth - listWrapperEl.clientWidth}`,
				scrub: true,
				pin: true,
				anticipatePin: 1,
				invalidateOnRefresh: true,
				//markers:true,
			});
			horizontalScroll.to(listEl, {
				x: () => -(listEl.clientWidth - listWrapperEl.clientWidth),
				ease: 'none',
				duration: (listEl.clientWidth - listWrapperEl.clientWidth)/(listEl.clientWidth - listWrapperEl.clientWidth + window.innerWidth) ,
			});
			let interviewItem = []
			gsap.utils.toArray(".p-footer-interview-item").forEach((target,num) => {
				interviewItem.push(gsap.timeline());
				ScrollTrigger.create({
					animation: interviewItem[num],
					trigger: target,
					start:'left right',
					end:'center left',
					//horizontal:true,
					markers:true,
					scrub:true,
					containerAnimation:horizontalScroll,
				});
				if (num % 2 === 0) {
					interviewItem[num].set(target,{y:-(window.innerHeight - listContent.clientHeight)/2*0.7});
					interviewItem[num].to(target,{y:(window.innerHeight - listContent.clientHeight)/2*0.7,ease:"power1.out",duration:1});
				} else {
					interviewItem[num].set(target,{y:(window.innerHeight - listContent.clientHeight)/2*0.7});
					interviewItem[num].to(target,{y:-(window.innerHeight - listContent.clientHeight)/2*0.7,ease:"power1.out",duration:1});
				}
			});
	} */


		if (mainElement.classList.contains('p-message-main')) {
			let messageMV = gsap.timeline();

			ScrollTrigger.create({
				animation: messageMV, // scenes配列から適切なtimelineを取得
				trigger: `.p-message-hero`,
				start: "top top",
				end: "+=50%",
				scrub: 1.25,
				yoyo: true,
				//toggleActions: "play pause resume reverse",
				//markers: true,
			});
			gsap.set('.p-message-hero__bg',{
				width: '100%',},0);
			messageMV.to('.p-message-hero__bg',{
				width: '50%',},0);

			for (let i = 1; i <= totalScenes; i++) {
				scenes.push(gsap.timeline());
				ScrollTrigger.create({
					animation: scenes[i - 1], // scenes配列から適切なtimelineを取得
					trigger: `.p-message-main .-interview0${i}`,
					start: "top top+=65%",
					end: "+=45%",
					scrub: 1.25,
					yoyo: true,
					//markers: true,
				});
				scenes[i - 1].addLabel("Label_1");
				scenes[i - 1].to(`.p-message-main .-bg-img${i}`, {opacity: 1,duration: 0.5,});
				scenes[i - 1].to(`.p-message-main .-bg-img${i}`,{ scale: 1, duration: 0.5 },0);
			}
		}

  }
}

//ロードとリサイズの両方で同じ処理を付与する
window.onload = switchByWidth;
if (window.matchMedia("(min-width:768px)").matches) {
	window.onresize = switchByWidth;
}

/*---------------------------------------------
	FAQ accordion
---------------------------------------------*/
const triggers = document.querySelectorAll(".js-accordion-trigger");
triggers.forEach((trigger) => {
  const controls = trigger.getAttribute("aria-controls");
  const panel = document.getElementById(controls);

  trigger.addEventListener("click", (e) => {
    const target = e.currentTarget;
    const isOpen = target.getAttribute("aria-expanded") === "true";
		
		function accordionOpen() {
			target.setAttribute("aria-expanded", "true");
			panel.classList.remove("-close");
		}
		
		function accordionClose() {
			target.setAttribute("aria-expanded", "false");
			panel.classList.add("-close");
		}

    if (isOpen) {
      // アコーディオンを閉じる
			if (target.classList.contains('-spOnly') == true) {
				if (window.matchMedia("(max-width: 767px)").matches) {
					accordionClose();
				}
			} else {
				accordionClose();
			}
    } else {
      // アコーディオンを開く
			if (target.classList.contains('-spOnly') == true) {
				if (window.matchMedia("(max-width: 767px)").matches) {
					accordionOpen();
				}
			} else {
				accordionOpen();
			}
    }
  });
});

/*---------------------------------------------
	Interview MV
---------------------------------------------*/
if (mainElement.classList.contains('p-interview-main')) {
	var winW = $(window).width();
	var winH = $(window).height();
	
	var scroll;

	const interviewElement = document.querySelector('.p-interview-profile__box');
	const height = interviewElement.offsetHeight;
	document.documentElement.style.setProperty('--interviewElement-height', `${height}px`);

	var interviewArticle = $('.p-interview-article');
	var objTop = interviewArticle.length ? interviewArticle.offset().top : 0;
	$(window).on('scroll', function () {
		scroll = $(window).scrollTop();
		if (scroll >= objTop - winH) {
			$(".p-interview-hero__bg").css({
				position: "absolute",
				bottom: "0"
			});
			if (window.matchMedia("(min-width: 992px)").matches) {
				$(".p-interview-nav ul").css({
					position: "fixed",
					bottom: "2.5rem",
					left: "4rem"
		/* >>>>>>> feature/知念対応分 */
				});
			}
		} else {
			$(".p-interview-hero__bg").css("position", "fixed");
			if (window.matchMedia("(min-width: 992px)").matches) {
				$(".p-interview-nav ul").css("position", "static");
			}
		}
	});

	let interviewMv = gsap.timeline();

	gsap.set(".p-interview-hero__img", {
		xPercent: -50,
		yPercent: 0,
	});
	ScrollTrigger.create({
		animation: interviewMv,
		toggleActions: "play none none reverse",
		trigger: ".p-interview-hero",
		start: "top top",
		end: "top top-=10%",
		yoyo: true,
		scrub:2,
		//markers:true,
	});
	interviewMv.to(".p-interview-hero__img", {
		width: '100vw',
		height: '100lvh',
		ease: "power1.inOut",
		transformOrigin: "center center",
    borderRadius: "0 0 0 0",
		left: "50%",
		top: "0%",
		xPercent: -50,
		yPercent: 0,
	});
	interviewMv.to(".p-interview-hero__bg", {
		height: '100lvh',
	},0);
}



/*---------------------------------------------
	canvas
---------------------------------------------*/
function createSvgData(scale) {
  return `<svg width="1600px" height="900px" viewBox="0 0 1600 900" xmlns="http://www.w3.org/2000/svg"><path d="M91.9,0c11.3,70.6,108.5,112.3,170.2,118.7c23.7,2.4,45.6,2.3,65.9,0.3c9.6,19.3,23,37,38.5,54.2
	c6.5,7.2,13.7,14.2,21.5,20.4c4.3,7.7,9.6,15,16.7,21.5c14.5,13.3,34.5,19.9,54,19.6c20-0.3,35.9-12.3,54.7-12.3
	c44.7-0.1,83.2,2,123.8-13.9c0.6,2.7,1.1,5.4,1.8,8c11.6,45.6,25.8,68.1,68.7,84.5c26,9.9,52.8,17.1,80,19.6
	c20.5,29.5,55.5,50.6,87.8,62.3c40.8,14.9,95.6-1.2,129,30.4c23.2,21.9,25,57.4,27.1,89.2c4.7,72.7,43.2,141.1,100.6,183.6
	c3.3,2.5,6.6,5,9.9,7.5c-8.5,5.7-18.5,11.4-30.1,17.1c0,0-197.5,131.7-9.1,189.2H1600V0H91.9z" fill="#FFFFFF"/><path transform="scale(${scale})" transform-origin="bottom left" d="M436,515c-64.3,1.5-122.7-18.1-179-45.8c-18.5-9.1-37.2-18.3-57.5-21.9c-7.9-1.4-16-1.6-24.1-0.8c-4.2,0.4-8.4,1.1-12.6,2
	c-16.6-31.8-49.9-53.6-88.3-53.6c-0.7,0-1.4,0-2.2,0C53.3,380.5,26.1,355.5,0,351.2V900h759.4C729.7,743.2,505.6,513.2,436,515
	L436,515z" fill="#FFFFFF"/></svg>`;
}

const gradationCanvas = () => {
  const container = document.querySelector('.p-top-main');

  if (container) {
			let app;
		if (window.matchMedia("(max-width: 767px)").matches) {
			app = new PIXI.Application({
				width: 179/2,
				height: Math.round(179/2 * window.innerHeight/window.innerWidth),
				backgroundColor: 0x080808,
				resolution: window.devicePixelRatio || 1,
			});
			/* container.appendChild(app.view); */
		} else if (window.matchMedia("(min-width:768px)").matches) {
			gsap.set(".p-footer-interview-item:nth-child(even)",{
				yPercent: 40,
			});
			gsap.to(".p-footer-interview-item:nth-child(even)",{
				yPercent: -25,
				scrollTrigger:{
					trigger:".p-footer-interview-content",
					start: "top bottom",
					end: "bottom top",
					scrub: .4,
					//markers:true,
				},
			});

			app = new PIXI.Application({
				width: 179,
				height: Math.round(179 * window.innerHeight/window.innerWidth),
				backgroundColor: 0x080808,
				resolution: window.devicePixelRatio || 1,
			});
		}
		container.appendChild(app.view);


    const svgData = `<svg width="1600px" height="900px" viewBox="0 0 1600 900" xmlns="http://www.w3.org/2000/svg"><path d="M91.9,0c11.3,70.6,108.5,112.3,170.2,118.7c23.7,2.4,45.6,2.3,65.9,0.3c9.6,19.3,23,37,38.5,54.2
		c6.5,7.2,13.7,14.2,21.5,20.4c4.3,7.7,9.6,15,16.7,21.5c14.5,13.3,34.5,19.9,54,19.6c20-0.3,35.9-12.3,54.7-12.3
		c44.7-0.1,83.2,2,123.8-13.9c0.6,2.7,1.1,5.4,1.8,8c11.6,45.6,25.8,68.1,68.7,84.5c26,9.9,52.8,17.1,80,19.6
		c20.5,29.5,55.5,50.6,87.8,62.3c40.8,14.9,95.6-1.2,129,30.4c23.2,21.9,25,57.4,27.1,89.2c4.7,72.7,43.2,141.1,100.6,183.6
		c3.3,2.5,6.6,5,9.9,7.5c-8.5,5.7-18.5,11.4-30.1,17.1c0,0-197.5,131.7-9.1,189.2H1600V0H91.9z" fill="#FFFFFF"/><path transform="scale(1)" transform-origin="bottom left" d="M436,515c-64.3,1.5-122.7-18.1-179-45.8c-18.5-9.1-37.2-18.3-57.5-21.9c-7.9-1.4-16-1.6-24.1-0.8c-4.2,0.4-8.4,1.1-12.6,2
		c-16.6-31.8-49.9-53.6-88.3-53.6c-0.7,0-1.4,0-2.2,0C53.3,380.5,26.1,355.5,0,351.2V900h759.4C729.7,743.2,505.6,513.2,436,515
		L436,515z" fill="#FFFFFF"/></svg>`;

    const base64 = window.btoa(unescape(encodeURIComponent(svgData)));
    const svgTexture = PIXI.Texture.from(`data:image/svg+xml;base64,${base64}`);
    
    const svgSprite = new PIXI.Sprite(svgTexture);
    svgSprite.width = app.screen.width;
    svgSprite.height = app.screen.height;

		// アンカーポイントを中心に設定する前に、スプライトの位置を調整します
		svgSprite.x = app.screen.width / 2;
		svgSprite.y = app.screen.height / 2;

		// スプライトのサイズを100%に設定
		svgSprite.scale.set(1);

		// アンカーポイントを中心に設定
		svgSprite.anchor.set(0.5);

    const maskedContainer = new PIXI.Container();
    app.stage.addChild(maskedContainer);
    maskedContainer.mask = svgSprite; // SVGスプライトをマスクとして設定

    // マスクをステージに追加しますが、表示はされません。マスクとして機能します。
    app.stage.addChild(svgSprite);


		// スクロール位置に基づいてscaleを計算する関数
		function calculateScaleBasedOnScroll() {
			const scrollY = window.scrollY;
			const maxScroll = window.innerHeight; // 100vhを最大のスクロール量とする
			// スクロール量に応じてスケールを1から1.7の範囲で変化させる
			// スクロールがmaxScrollの値を超えた場合、スケールが1.7を超えないようにする
			const scale = Math.min(1 + (scrollY / maxScroll) * 0.7, 1.7);
			return scale;
		}

		function updateSvgTextureOnScroll() {
			let mvGrad = gsap.timeline()
			const testScale = gsap.fromTo(svgSprite.scale,{
					x: 1, // 横スケールを1.7に
					y: 1, // 縦スケールを1.7に
				}, {
					x: 1.7, // 横スケールを1.7に
					y: 1.7, // 縦スケールを1.7に
					duration: 0.3, // アニメーションの持続時間
					ease: "power1.inOut", // イージングの種類
					onUpdate: () => updateTexture(svgSprite.scale.x), // スケールが変化するたびにテクスチャを更新
					paused: true // アニメーションをすぐには開始しない
				});
			/* gsap.set(".p-top-company__section.-section02",{opacity:0,translateY:"10vh"}); */
			ScrollTrigger.create({
				animation: mvGrad,
				trigger: ".p-top-hero__section.-section04", // この要素がビューポートに入るとアニメーションが始まります
				start: "top top", // トリガー要素の上部がビューポートの中央に達した時に開始
				end: "+=100%",
				scrub:true,
				yoyo:true,
				onEnter: () => {
					testScale.play();
					/* gsap.to("canvas",{opacity:1,scale:1.25,duration: 1});
					gsap.to(".p-top-company__section.-section02",{opacity:1,translateY:"0vh",duration: 0.6}); */
				}, // スクロールダウンでアニメーション開始
				onLeaveBack: () => {
					testScale.reverse();
					/* gsap.to("canvas",{opacity:0,scale:1,duration: 1}); */
				}, // スクロールアップでアニメーションを逆再生
				//markers:true,
			});
			/* mvGrad.to(
				".p-top-hero__mainLogo.-logo02",{transform:'translateY(-90vh)',ease: "none",},"+=0.1"
			); */

			function updateTexture(scale) {
				const newSvgData = createSvgData(scale); // 新しいSVGデータを生成
				const newBase64 = window.btoa(unescape(encodeURIComponent(newSvgData)));
				const newTexture = PIXI.Texture.from(`data:image/svg+xml;base64,${newBase64}`);
				svgSprite.texture = newTexture; // スプライトに新しいテクスチャを設定
			}
		}


    // 円を作成してコンテナに追加する関数
    const numCircles = 213;
    const colors = [0xFF0000, 0x00FF00, 0x0000FF]; // 色を定義
    
    function createCircle(color) {

			const circle = new PIXI.Graphics();
			if (window.matchMedia("(max-width: 767px)").matches) {
					circle.beginFill(color)
					.drawCircle(0, 0, app.screen.width * 0.12)
					.endFill();
			} else if (window.matchMedia("(min-width:768px)").matches) {
					circle.beginFill(color)
					.drawCircle(0, 0, app.screen.width * 0.06)
					.endFill();
			}

      circle.x = Math.random() * app.screen.width;
      circle.y = Math.random() * app.screen.height;
      circle.speedX = (Math.random() - 0.5) * window.innerWidth * 0.000186011904762;
      circle.speedY = (Math.random() - 0.5) * window.innerHeight * 0.000186011904762;
      //circle.speedY = (Math.random() - 0.5) * 2 / 6;
      circle.blendMode = PIXI.BLEND_MODES.SCREEN;
      maskedContainer.addChild(circle);
    }

    colors.forEach(color => {
      for (let i = 0; i < numCircles / colors.length; i++) {
        createCircle(color);
      }
    });

    // ブラーフィルターを再度適用します。
    const blurFilter = new PIXI.filters.BlurFilter();
    blurFilter.blur = 36;
    blurFilter.quality = 30;
		//blurFilter.padding = 100;
    blurFilter.resolution = 1;
    blurFilter.kernelSize = 5;
    maskedContainer.filters = [blurFilter];

		function moveChildren() {
			maskedContainer.children.forEach(child => {
				child.x += child.speedX;
				child.y += child.speedY;
		
				// スクリーンの端で反転するロジック
				if (child.x < 0 || child.x > app.screen.width) {child.speedX *= -1;}
				if (child.y < 0 || child.y > app.screen.height) {child.speedY *= -1;}
			});
		}

    // アニメーション用のアップデート関数
    app.ticker.add(moveChildren);


		let elapsed = 0;
		const animationStartTime = 5; // 5秒後にアニメーションを開始
		let animationStarted = false;
		
		
    /* if (isBelowTrigger) {
			console.log("トリガー要素より下にいます。");
	} else {
			console.log("トリガー要素より上にいます。");
	} */
		app.ticker.add(() => {
			if (!animationStarted && isBelowTrigger) {
				// 円を作成し、初期位置を設定する関数
				function createCircle(color, posX, posY) {
					const circle = new PIXI.Graphics();
					circle.beginFill(color);
					circle.drawEllipse(0, 0, app.screen.width / 2.2, app.screen.height / 2);
					circle.endFill();
					circle.x = posX;
					circle.y = posY;
					circle.speedX = 0;
					circle.speedY = 0;
					circle.initialX = posX;
					circle.initialY = posY;
					circle.alpha = 0.95;
					
					circle.blendMode = PIXI.BLEND_MODES.SCREEN;
					maskedContainer.addChild(circle);
					blurFilter.blur = 50;
					return circle;
				}

				const MAX_DISTANCE = 25; // 中心からの最大距離

				function startRandomMovement(circle) {
					function randomTarget() {
						const angle = Math.random() * Math.PI * 2; // 0 から 2πの間のランダムな角度
						const distance = Math.random() * MAX_DISTANCE; // 最大距離の範囲内でランダムな距離
						return {
							x: centerX + distance * Math.cos(angle),
							y: centerY + distance * Math.sin(angle)
						};
					}

					let target = randomTarget();

					function randomMove() {
						const dx = target.x - circle.x;
						const dy = target.y - circle.y;
						const distance = Math.sqrt(dx * dx + dy * dy);

						if (distance > 5) {
							circle.x += dx / distance * 0.1;
							circle.y += dy / distance * 0.1;
						} else {
							target = randomTarget(); // 新しい目標位置を決定
						}

					}

					app.ticker.add(randomMove);
				}


				const centerX = app.screen.width / 2;
				const centerY = app.screen.height / 2;

				// 中心にサークルを移動させる関数
				function moveCircleToCenter(circle, onComplete) {
					const dx = centerX - circle.x;
					const dy = centerY - circle.y;
					const distance = Math.sqrt(dx * dx + dy * dy);

					if (distance > 5) {
						circle.x += dx / distance * 5;
						circle.y += dy / distance * 5;
					} else {
						circle.x = centerX;
						circle.y = centerY;
						circle.initialX = circle.x; // 新しい初期X座標を保存
						circle.initialY = circle.y; // 新しい初期Y座標を保存
						onComplete(circle);
					}
				}

				// 中心に集まった後、ランダムに動き始める

				// 中心に集まった後、ランダムに動き始める
				function startRandomMovementAfterCentering(circle) {
					const moveFunction = () => {
						moveCircleToCenter(circle, () => {
							app.ticker.remove(moveFunction);
							startRandomMovement(circle);
						});
					};

					app.ticker.add(moveFunction);
				}


				// 円を作成し、中心に移動させる
				const colors = [0xFF0000, 0x00FF00, 0x0000FF/* , 0x00FFFF */];
				const positions = [{x:0, y:0}, {x: app.screen.width, y: 0}, {x: 0, y: app.screen.height}, {x: app.screen.width, y: app.screen.height}];


				maskedContainer.removeChildren();
				app.ticker.remove(moveChildren);
				positions.forEach((pos, index) => {
					const circle = createCircle(colors[index], pos.x, pos.y);
					startRandomMovementAfterCentering(circle);
				});
				animationStarted = true;
			}
		});

  // 既存のアニメーション用のアップデート関数の後に追加
  updateSvgTextureOnScroll();
  }
};

document.addEventListener('DOMContentLoaded',gradationCanvas);

document.addEventListener('DOMContentLoaded', function() {
	var customCursor = document.getElementById('custom-cursor');
	if (customCursor) {
	var footerArea = document.querySelector('.p-footer.-cursor');
	var allClickableElements = footerArea.querySelectorAll('a, button, input');
	var lastMouseX = 0;
	var lastMouseY = 0;
	var scrollStartX = window.scrollX;
	var scrollStartY = window.scrollY;
	var isScrolling = false;
	
	/* footerArea.addEventListener('mousemove', function(e) {
			var rect = footerArea.getBoundingClientRect();
			lastMouseX = e.clientX - rect.left;
			lastMouseY = e.clientY - rect.top;
			if (isScrolling) {
					// スクロール中にマウスが動いたら、スクロールの影響をリセット
					scrollStartX = window.scrollX;
					scrollStartY = window.scrollY;
					isScrolling = false;
			}
			updateCursor(lastMouseX, lastMouseY);
	});
	
	window.addEventListener('scroll', function() {
			if (!isScrolling) {
					// スクロールが始まったら開始時の座標を記録
					scrollStartX = window.scrollX;
					scrollStartY = window.scrollY;
					isScrolling = true;
			}
			var scrolledX = window.scrollX - scrollStartX;
			var scrolledY = window.scrollY - scrollStartY;
			updateCursor(lastMouseX + scrolledX, lastMouseY + scrolledY);
	}); */
	
	function updateCursor(x, y) {
			customCursor.style.left = x + 'px';
			customCursor.style.top = y + 'px';
			customCursor.style.opacity = 0.6;
	}


	// フッターエリア外でのマウス移動を追跡（カーソルを非表示にする）
	document.addEventListener('mousemove', function(e) {
			if (!footerArea.contains(e.target)) {
					customCursor.style.opacity = 0; // カーソルを非表示
			}
	});

	// フッターエリア内のクリッカブルな要素にホバーしたときの処理
	allClickableElements.forEach(function(element) {
			element.addEventListener('mouseenter', function() {
					customCursor.style.transform = 'translate(-50%, -50%) scale(1.2)'; // サークルを拡大
			});

			element.addEventListener('mouseleave', function() {
					customCursor.style.transform = 'translate(-50%, -50%) scale(1)'; // サークルを元のサイズに戻す
			});
	});
	}
});


let isBelowTrigger = false;
if (document.querySelector('.p-top-company__section.-section01')){
	ScrollTrigger.create({
			//animation: about,
			trigger: ".p-top-company__section.-section01",
			start: "top center",
			end: `"+=${document.documentElement.scrollHeight}`,
			onToggle: self => {
				isBelowTrigger = self.isActive;
				//gsap.to("canvas",{opacity:1,scale:1.25,duration: 1});
				/* gsap.to(".p-top-company__section.-section02",{opacity:1,translateY:"0vh",duration: 0.6}); */
			},
			/* onLeave: () => {
				//gsap.to("canvas",{opacity:1,scale:1.25,duration: 1});
				gsap.to(".p-top-company__section.-section02",{opacity:1,translateY:"0vh",duration: 0.6});
			}, // スクロールダウンでアニメーション開始 */
			// スクロールアップでアニメーションを逆再生
			//toggleActions: "play play play play",
			//onLeaveBack: () => {
			//	gsap.to("canvas",{opacity:0,scale:1,duration: 1});
			//},
			//markers: true,
	});
}